module.exports = __webpack_public_path__ + "static/media/modalImage@2x.eb060550.png";